// @ts-nocheck
import { useActions, useAppSelector } from '@/hooks'

import Header from '@/modules/devices-list/components/Header/Header'
import { UnitSearchReq } from '@/modules/devices-list/types/newUnitsType'
import PlacemarkBalloon from '@/modules/maps/components/PlacemarkBalloon'
import {
  useGetDetailUnitClusterMutation,
  useGetDetailUnitMutation,
  useGetUnitsHomeMapMutation,
} from '@/modules/maps/services/homeMapService'
import MyPolyLine from './components/PolyLine'
import { filterSystemSelector } from '@/store/filterSystemsSlise'
import { unitsSelector } from '@/store/unitsSlise'
import cn from 'classnames'
import { Box } from '@mui/material'
import {
  Circle,
  Clusterer,
  Map,
  TypeSelector,
  useYMaps,
  ZoomControl,
} from '@pbe/react-yandex-maps'
import React, { useEffect, useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import dayjs from 'dayjs'
import ymaps from 'yandex-maps'
import Loader from '@/components/Atoms/Loader/Loader'
import { balloonCluster } from '@/components/Organisms/Map/balloonsDtp'
import { getColorUnit } from '@/components/Organisms/Map/MapDTP'
import MapCircle from '@/modules/maps/components/Circle'
import DtpPlacemark from '@/modules/maps/components/DtpPlacemark'

const DEFAULT_RES_POINTS = [
  [48.024402067130715, 39.85466330972504],
  [46.780699672601415, 39.807971415195674],
]

const MAP_OPTIONS = {
  yandexMapDisablePoiInteractivity: true,
}
const MAP_STATE = {
  center: [47.2313, 39.7233],
  zoom: 9,
  controls: [],
}
export const MAP_ZOOM_OPTIONS = {
  position: {
    right: '10px',
    left: 'auto',
    top: '364px',
    bottom: 'auto',
  },
}
const HomeMap = () => {
  const yamap = useRef<any>()

  const units = useAppSelector(unitsSelector)
  console.log(units)
  const mapPoints =
    units?.data?.data?.filter(
      (unit) =>
        unit.typeId !== 14 &&
        unit.typeId !== 16 &&
        unit.typeId !== 17 &&
        unit.typeId !== 15
    ) || []

  const mapPolylines =
    units?.data?.data?.filter((unit) => unit.typeId === 14) || []

  const mapDtp = units?.data?.data?.filter((unit) => unit.typeId === 15) || []

  const mapDtpCircles =
    units?.data?.data?.filter(
      (unit) => unit.typeId === 16 || unit.typeId === 17
    ) || []

  const [getUnitService, { isLoading, data }] = useGetUnitsHomeMapMutation()
  const {
    filter,
    searchValue,
    isSearch,
    favoriteId,
    deviceStateFilter,
    startDate,
    endDate,
    additionalFilter,
  } = useAppSelector(filterSystemSelector)
  const {
    setSearchValue,
    setSelectedTab,
    setFilter,
    setStartDate,
    setEndDate,
  } = useActions()
  const [searchParams] = useSearchParams()
  const [zoomState, setZoomState] = useState(MAP_STATE.zoom)
  const [points, setPoints] = useState<number[]>([])
  const [center, setCenter] = useState<number[]>([47.2313, 39.7233])
  const [openBalloon, setOpenBalloon] = React.useState(false)
  const [isDeleteCluster, setIsDeleteCluster] = React.useState(false)

  const onGetUnits = async () => {
    try {
      const isLightning = filter.length === 1 && filter[0] === 14
      const usersSearchData: Omit<UnitSearchReq, 'page'> = {
        value: !searchValue.trim().length ? '' : searchValue,
        deviceTypeFilter: filter,
        additionalFilter: additionalFilter,
        startDate: startDate ? startDate.toISOString() : '',
        endDate: endDate ? endDate.toISOString() : '',
        includeAccidents: true,
        includeTotals: true,
        deviceStateFilter: isLightning ? [0] : deviceStateFilter,
        favoriteId: favoriteId,
        lightingTypeId:
          deviceStateFilter?.length > 1 || filter.length > 1
            ? 0
            : deviceStateFilter[0],
      }
      const res = await getUnitService(usersSearchData).unwrap()
      if (res.success) {
        const { data } = res?.data
        if (!data?.length) {
          setPoints(pointsIfEmpty)
          return
        }

        const mapPoints = data
          .filter((unit) => unit.typeId !== 14)
          .map((unit) => unit.coordinates)
        const polylinePoints = data
          .filter((unit) => unit.typeId === 14)
          .flatMap((unit) => unit.coordinates)

        setPoints([...mapPoints, ...polylinePoints])
        setTimeout(() => {
          const lat = searchParams.get('lat')
          const lng = searchParams.get('lng')
          if (lat && lng) {
            const latNumber = Number(lat)
            const lngNumber = Number(lng)
            if (!isNaN(latNumber) && !isNaN(lngNumber)) {
              console.log('set center after get data')
              yamap?.current?.setCenter([latNumber, lngNumber], 15)
            }
          }
        }, 1000)
      }
      if (!searchValue.trim().length) {
        setSearchValue('')
      }
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    const deviceId = searchParams.get('deviceId')
    if (deviceId) {
      const deviceIdNumber = Number(deviceId)
      if (!isNaN(deviceIdNumber)) {
        setFilter([deviceIdNumber])
        localStorage.setItem(
          'filterValueDevices',
          JSON.stringify([deviceIdNumber])
        )
      }
    }

    const year = searchParams.get('year')
    if (year) {
      const yearNumber = Number(year)
      if (!isNaN(yearNumber)) {
        const startOfYear = dayjs().year(yearNumber).startOf('year')
        const endOfYear = dayjs().year(yearNumber).endOf('year')
        setStartDate(startOfYear)
        setEndDate(endOfYear)
      }
    }
  }, [searchParams, setFilter, setStartDate, setEndDate])

  useEffect(() => {
    onGetUnits().then()
    setSelectedTab(0)
  }, [
    isSearch,
    deviceStateFilter,
    startDate,
    endDate,
    filter,
    additionalFilter,
  ])

  const closeBalloon = () => {
    const close: any = document.querySelector(
      'ymaps[class$="-balloon__close-button"]'
    )
    if (close != null) {
      close.click()
    }
  }

  const handleResizeMap = (e: any) => {
    console.log('Zoom = ', e.originalEvent.newZoom)
    setZoomState(e.originalEvent.newZoom)
    // if (e.originalEvent.newZoom > 20) {
    //   setIsDeleteCluster(true)
    // } else {
    //   setIsDeleteCluster(false)
    // }
  }

  const onSetBounds = (e: typeof ymaps) => {
    console.log('set center onSetBounds')
    const lat = searchParams.get('lat')
    const lng = searchParams.get('lng')
    if (!lat && !lng) {
      const bounds = e.util.bounds.fromPoints(points)
      console.log('onSetBounds2')
      yamap?.current?.setBounds(bounds, {
        checkZoomRange: true,
      })
    }
  }
  const map = useYMaps()

  useEffect(() => {
    const bounds = map?.util.bounds.fromPoints(points)

    if (bounds) {
      const padding = 0.05
      const expandedBounds = [
        [bounds[0][0] - padding, bounds[0][1] - padding],
        [bounds[1][0] + padding, bounds[1][1] + padding],
      ]
      yamap?.current?.setBounds(expandedBounds, {
        checkZoomRange: true,
      })
    }
  }, [data, points])

  const [getDetailUnit] = useGetDetailUnitMutation()
  const onLoadData = async (id: number) => {
    try {
      await getDetailUnit(id).unwrap()
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <>
      {isLoading && <Loader />}
      <Box className={cn('home-map', { loading: isLoading })}>
        <Header isMap />
        <Map
          instanceRef={yamap}
          state={MAP_STATE}
          options={MAP_OPTIONS}
          onClick={closeBalloon}
          modules={['control.ZoomControl', 'util.bounds']}
          className='map_container'
          onLoad={onSetBounds}
          onBoundsChange={handleResizeMap}
        >
          <ZoomControl options={MAP_ZOOM_OPTIONS} />

          {mapPolylines.map((unit) => {
            return (
              <MyPolyLine
                key={unit.id}
                // @ts-ignore
                unit={unit}
              />
            )
          })}

          {mapDtp.map((unit) => (
            <DtpPlacemark
              key={unit.id}
              unit={unit}
              unitTotal={mapDtp.length}
              zoomState={zoomState}
            />
          ))}

          {mapDtpCircles.map((unit) => (
            <MapCircle
              key={unit.id}
              unit={unit}
              zoomState={zoomState}
              yMap={yamap}
            />
          ))}

          {mapPoints.map((unit) => {
            return (
              <PlacemarkBalloon
                key={unit.id}
                unit={unit}
                yamap={yamap}
              />
            )
          })}
        </Map>
      </Box>
    </>
  )
}

export default HomeMap
